import { useState } from "react";
import { Form, Formik, FormikProps } from "formik";
import Typography from "../../../designComponents/Typography";
import Button from "../../../designComponents/Button";
import { PropertyAddressType } from "./types";
import Select from "../../../designComponents/Select";
import Input from "../../../designComponents/Input";
import { AddPropertyProps } from ".";

const propertyType = [
  { value: "DETACHED_HOUSE", label: "Detached House" },
  { value: "SEMI_DETACHED_HOUSE", label: "Semi Detached House" },
  { value: "TERRACED_HOUSE", label: "Terraced House" },
  { value: "APARTMENT", label: "Apartment" },
];

const furnishedType = [
  { value: "FURNISHED", label: "Furnished" },
  { value: "UNFURNISHED", label: "Unfurnished" },
];

const rentalMarket = [
  { value: "FAMILY", label: "Family" },
  { value: "PROFESSIONALS", label: "Professionals" },
  { value: "STUDENTS", label: "Students" },
  { value: "CO-HABIT", label: "Co-habit" },
];

const berRating = [
  { value: "A1", label: "A1" },
  { value: "A2", label: "A2" },
  { value: "A3", label: "A3" },
  { value: "A4", label: "A4" },
  { value: "B1", label: "B1" },
  { value: "B2", label: "B2" },
  { value: "C1", label: "C1" },
  { value: "C2", label: "C2" },
  { value: "D1", label: "D1" },
  { value: "D2", label: "D2" },
];

const BasicInformation = ({
  initialValues,
  onUpdate,
  gotoPrevious,
  errorMessage,
  loading,
}: AddPropertyProps) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <Typography style={{ marginBottom: "10px" }} size="h3">
        Step 2: Basic Information
      </Typography>

      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={(values) => {
          const dataTosubmit = {
            ...values,
            price: values.price,
          };
          onUpdate(dataTosubmit);
        }}
      >
        {(formikProps: FormikProps<PropertyAddressType>) => (
          <Form>
            <div style={{ marginBottom: "20px" }}>
              <Select
                label="Property Type"
                options={propertyType}
                name="propertyType"
                placeholder="Select Property Type"
                formikProps={formikProps}
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <Select
                label="Furnished Type"
                options={furnishedType}
                name="furnishedType"
                placeholder="Select Furnished Type"
                formikProps={formikProps}
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <Select
                label="Rental Market"
                options={rentalMarket}
                name="rentalMarket"
                placeholder="Select Rental Market"
                formikProps={formikProps}
              />
            </div>
            <div style={{ marginBottom: "20px" }}>
              <Select
                label="Ber Number"
                options={berRating}
                name="berRating"
                placeholder="Select Ber Number"
                formikProps={formikProps}
              />
            </div>

            <div style={{ display: "flex", gap: "50px", marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                }}
              >
                <Typography>No. of Bedrooms</Typography>
                <Button
                  onClick={() => {
                    if (
                      formikProps.values.bedrooms &&
                      formikProps.values.bedrooms > 1
                    ) {
                      formikProps.setFieldValue(
                        "bedrooms",
                        formikProps.values.bedrooms - 1
                      );
                    }
                  }}
                  type="button"
                >
                  -
                </Button>
                <Input
                  name="bedrooms"
                  value={formikProps.values.bedrooms}
                  onChange={formikProps.handleChange}
                  style={{ maxWidth: "30px", textAlign: "center" }}
                />
                <Button
                  type="button"
                  onClick={() => {
                    formikProps.setFieldValue(
                      "bedrooms",
                      (formikProps.values.bedrooms || 1) + 1
                    );
                  }}
                >
                  +
                </Button>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                }}
              >
                <Typography>No. of Bathrooms</Typography>
                <Button
                  onClick={() => {
                    if (
                      formikProps.values.bathrooms &&
                      formikProps.values.bathrooms > 1
                    ) {
                      formikProps.setFieldValue(
                        "bathrooms",
                        formikProps.values.bathrooms - 1
                      );
                    }
                  }}
                  type="button"
                >
                  -
                </Button>
                <Input
                  name="bathrooms"
                  value={formikProps.values.bathrooms}
                  onChange={formikProps.handleChange}
                  style={{ maxWidth: "30px", textAlign: "center" }}
                />
                <Button
                  type="button"
                  onClick={() => {
                    if (formikProps.values.bathrooms) {
                      formikProps.setFieldValue(
                        "bathrooms",
                        (formikProps.values.bathrooms || 1) + 1
                      );
                    }
                  }}
                >
                  +
                </Button>
              </div>
            </div>

            <div style={{ display: "flex", gap: "50px", marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                }}
              >
                <Typography>Maximum Occupancy</Typography>
                <Button
                  onClick={() => {
                    if (
                      formikProps.values.maximumOccupancy &&
                      formikProps.values.maximumOccupancy > 1
                    ) {
                      formikProps.setFieldValue(
                        "maximumOccupancy",
                        formikProps.values.maximumOccupancy - 1
                      );
                    }
                  }}
                  type="button"
                >
                  -
                </Button>
                <Input
                  name="maximumOccupancy"
                  value={formikProps.values.maximumOccupancy}
                  onChange={formikProps.handleChange}
                  style={{ maxWidth: "30px", textAlign: "center" }}
                />
                <Button
                  type="button"
                  onClick={() => {
                    formikProps.setFieldValue(
                      "maximumOccupancy",
                      (formikProps.values.maximumOccupancy || 1) + 1
                    );
                  }}
                >
                  +
                </Button>
              </div>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <Typography style={{ fontSize: "12px", color: "#666" }}>
                Maximum Occupancy defines the maximum number of tenants that can be attached to contracts or applications for this property. 
                Suggested: {formikProps.values.bedrooms ? formikProps.values.bedrooms * 2 : 0} tenants ({formikProps.values.bedrooms || 0} bedrooms × 2)
              </Typography>
            </div>

            <div style={{ display: "flex", gap: "50px", marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}
              >
                <Typography>Area (Sq.ft)</Typography>
                <Input
                  name="area"
                  placeholder="Enter area in sq.ft"
                  value={formikProps.values.area}
                  onChange={formikProps.handleChange}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <Typography>Rent Per Month</Typography>
                {/* <Typography>€ 0.00</Typography> */}
                <Input
                  name="price"
                  value={formikProps.values?.price}
                  onChange={formikProps.handleChange}
                />
              </div>
            </div>
            {errorMessage && (
              <Typography style={{ color: "red", marginBottom: "10px" }}>
                {errorMessage}
              </Typography>
            )}
            <div style={{ display: "flex", gap: "20px" }}>
              <Button
                type="button"
                radius="normal"
                onClick={gotoPrevious}
                isDisabled={loading}
              >
                Previous
              </Button>
              <Button type="submit" radius="normal" isLoading={loading}>
                Next
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default BasicInformation;
